import React, { useState, useEffect } from 'react';
// import { Form, Checkbox, Select, Input } from 'antd';
import {
  Input,
  Row,
  Col,
  Select,
  Form,
  Radio,
  Button,
  Typography,
  Progress,
  message
} from 'antd';
// import AboutMe from './AboutMe';
// import Education from './Education';
import styles from '../styles.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { DeleteOutlined } from '@ant-design/icons';
// import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import {
  createEducationDetails,
  getCityDetails,
  getHigherEducationOptions
} from '../../redux/slice';
import { event } from '../../../../utilities/gtag';

const Edit = ({
  // education_list,
  department_details,
  country_codes,
  city_details,
  state_details,
  user_data,
  currency_data,
  education_level_listdata
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { Text } = Typography;

  const { createEducationDetailsloading } = useSelector(
    (state) => state.editeducation
  );
  // console.log('education_degree_listdata', education_degree_listdata);
  const [income, setIncome] = useState('');
  const [education_degree_listdata, setEducationDegreeListdata] = useState({});
  const [educationFields, setEducationFields] = useState([
    {
      id: '',
      education_level_id: undefined,
      higher_education_id: undefined,
      institute_name: ''
    }
  ]);

  // console.log('Profile_ID:', params.id);

  const onFinish = async (values) => {
    event({
      action: 'profile_creation', // event name
      category: 'Education Creation',
      label: 'Profile Form Submitted',
      value: 1
    });
    // console.log('Edit_Education_details', values);

    // const userEducations = values.education_level.map((level, index) => ({
    //   education_level_id: level, // Extracts education_level
    //   higher_education_id: values.education[index], // Extracts corresponding education
    //   institute_name: values.name_institute[index],
    //   id: values.id || null // Extracts corresponding institute
    // }));

    const payload = {
      profile_id: params.id,
      user_educations: values.highestEducation,
      employed_in: values.employmentType,
      department_id: values.department,
      annual_income: values.annual_income,
      currency_code_id: values.currency,
      company_name: values.companyName,
      designation: values.designation,
      country_id: values.country,
      city_id: values.city,
      state_id: values.state
    };

    // console.log('Payload_familyDetails', payload);
    try {
      // console.log('Form Submitted:', payload);
      const response = await dispatch(createEducationDetails(payload)).unwrap(); // Dispatch Redux action
      if (response?.success) {
        // localStorage.setItem('profile_id', response.profile_id); // Store profile ID
        // navigate(`/edithoroscope/${response.profile_id}`); // Redirect on success
        message.success(response.message || 'Form submitted successfully!');
        navigate(`/edithoroscope`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error(
        error?.message || 'Failed to submit the form. Please try again.'
      );
    }
  };

  // const [form] = Form.useForm();
  // Tabs Data //
  const routes = {
    'About Me': '/editprofile',
    'Family Details': '/editfamily',
    'Education & Career': '/editeducation',
    Horoscope: '/edithoroscope',
    Contact: '/editcontact',
    'Desired Partner': '/editpartner',
    Membership: '/membership_payment'
  };
  const handleSectionClick = (section) => {
    if (routes[section]) {
      navigate(routes[section]);
    }
  };
  const activeTab = Object.entries(routes).find(
    ([, path]) => location.pathname === path
  )?.[0];
  // Tabs Data

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userName =
    matUserObject.user_details.first_name +
    ' ' +
    matUserObject.user_details.last_name;

  const options = [
    'Government/PSU',
    'Private',
    'Business',
    'Defence',
    'Self-Employed',
    'Not Working'
  ];
  useEffect(() => {
    if (educationFields.length > 0) {
      form.setFieldsValue({
        highestEducation: educationFields
      });
    }
  }, [educationFields]);

  useEffect(() => {
    if (user_data?.Profiles?.[0]) {
      const education_details = user_data?.Profiles?.[0];

      if (education_details?.ProfileEducations?.length) {
        const educationValues = education_details?.ProfileEducations.map(
          (edu) => ({
            education_level_id: edu.education_level_id || null,
            higher_education_id: edu.higher_education_id || null,
            id: edu.id, // Include id for edit
            institute_name: edu.institute_name || null
          })
        );

        // Dynamically set the number of education fields
        // setEducationFields(educationValues.map((_, index) => index));

        // educationValues.forEach((edu, index) => {
        //   console.log(`Education ${index + 1}:`);
        //   console.log(`- Education Level ID: ${edu.education_level_id}`);
        //   console.log(`- Higher Education ID: ${edu.higher_education_id}`);
        //   console.log(`- ID: ${edu.id}`);
        //   console.log(`- Institute Name: ${edu.institute_name}`);
        // });
        setEducationFields(educationValues);

        // console.log('educationFields', educationFields);
        form.setFieldsValue({
          highestEducation: educationFields,
          employmentType: education_details?.employed_in,
          department: education_details?.Department?.id,
          currency: education_details?.currency_code_id,
          annual_income: education_details?.annual_income,
          companyName: education_details?.company_name,
          designation: education_details?.designation,
          country: education_details?.Country?.id,
          state: education_details?.State?.id,
          city: education_details?.City?.id
        });
        console.log(
          'education_details?.currency_code_id',
          education_details?.currency_code_id
        );
        // educationValues.forEach((edu) => {
        //   if (edu.education_level_id) {
        //     fetchHigherEducationData(edu.education_level_id);
        //   }
        // });
        educationValues.forEach((edu, index) => {
          if (edu.education_level_id) {
            fetchHigherEducationData(edu.education_level_id, index);
          }
        });
      }
    }
  }, [user_data]);

  const addEducationField = () => {
    const newEducationFields = [
      ...educationFields,
      {
        id: '',
        education_level_id: undefined, // ✅ Set `undefined` to allow placeholder text
        higher_education_id: undefined,
        institute_name: ''
      }
    ];

    setEducationFields(newEducationFields);

    // ✅ Update form fields
    form.setFieldsValue({
      highestEducation: newEducationFields
    });
  };

  const removeEducationField = (index) => {
    const updatedFields = educationFields.filter((_, i) => i !== index);
    setEducationFields(updatedFields);
    // ✅ Also update form fields to remove the deleted row
    form.setFieldsValue({
      highestEducation: updatedFields
    });
  };

  // const handleFieldChange = (index, field, value) => {
  //   const updatedFields = [...educationFields];
  //   updatedFields[index] = { ...updatedFields[index], [field]: value };

  //   setEducationFields(updatedFields);
  //   form.setFieldsValue({ highestEducation: updatedFields });
  // };

  const handleFieldChange = async (index, field, value) => {
    setEducationFields((prevFields) => {
      const updatedFields = [...prevFields];

      // Prevent unnecessary updates if the same value is selected again
      if (updatedFields[index]?.[field] === value) return prevFields;

      updatedFields[index] = { ...updatedFields[index], [field]: value };

      if (field === 'education_level_id') {
        updatedFields[index].higher_education_id = undefined; // Reset degree

        dispatch(getHigherEducationOptions({ education_level_id: value })).then(
          (res) => {
            if (res?.payload?.data && Array.isArray(res?.payload?.data)) {
              setEducationDegreeListdata((prevData) => ({
                ...prevData,
                [value]: res?.payload?.data // Store each education_level_id's data separately
              }));
              // Ensure degrees are filtered correctly
              updatedFields[index].degreeOptions = res?.payload?.data.filter(
                (degree) => degree.education_level_id === value
              );
              setEducationFields([...updatedFields]); // Update state properly
            } else {
              console.error('Unexpected response:', res);
              updatedFields[index].degreeOptions = []; // Set empty array if no data
              setEducationFields([...updatedFields]);
            }
          }
        );
      }

      form.setFieldsValue({ highestEducation: updatedFields });

      return updatedFields;
    });
  };

  // const fetchHigherEducationData = async (education_level_id, index) => {
  //   try {
  //     const res = await dispatch(
  //       getHigherEducationOptions({ education_level_id })
  //     );

  //     if (res?.payload && Array.isArray(res.payload)) {
  //       setEducationFields((prevFields) => {
  //         const updatedFields = [...prevFields];

  //         // Ensure the correct field is updated with fetched data
  //         updatedFields[index] = {
  //           ...updatedFields[index],
  //           degreeOptions: res.payload, // Store the fetched degrees
  //           higher_education_id:
  //             updatedFields[index]?.higher_education_id || undefined // Preserve existing value if available
  //         };

  //         return updatedFields;
  //       });
  //     } else {
  //       console.error('Unexpected response:', res);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching higher education data:', error);
  //   }
  // };

  const fetchHigherEducationData = async (education_level_id, index) => {
    try {
      const res = await dispatch(
        getHigherEducationOptions({ education_level_id })
      );
      // console.log('res?.payload', res?.payload?.data);
      if (res?.payload?.data && Array.isArray(res?.payload?.data)) {
        setEducationDegreeListdata((prevData) => ({
          ...prevData,
          [education_level_id]: res?.payload?.data // Store each education_level_id's data separately
        }));

        setEducationFields((prevFields) => {
          const updatedFields = [...prevFields];

          updatedFields[index] = {
            ...updatedFields[index],
            degreeOptions: res.payload?.data, // Store degree options per field
            higher_education_id:
              updatedFields[index]?.higher_education_id || undefined
          };

          return updatedFields;
        });
      } else {
        console.error('Unexpected response:', res);
      }
    } catch (error) {
      console.error('Error fetching higher education data:', error);
    }
  };

  const percent = user_data?.user_score;

  const getStrokeColor = (percent) => {
    if (percent <= 30) return '#ff4d4f'; // Red
    if (percent <= 50) return '#fa8c16'; // Orange
    if (percent <= 80) return '#fadb14'; // Yellow
    return '#52c41a'; // Green
  };

  const handleCityChange = (cityId) => {
    form.setFieldsValue({ state: '', country: '' }); // Clear previous values
    fetchStateAndCountry(cityId); // Fetch new values
  };

  const fetchStateAndCountry = async (cityId) => {
    try {
      const response = await dispatch(getCityDetails(cityId));
      // console.log('Full Response:', response); // Debug full response structure

      // Check if the response contains valid data
      if (response?.payload?.data) {
        const { State } = response.payload.data; // Ensure accurate destructuring

        if (State) {
          // Safely update form values
          form.setFieldsValue({
            // state: State?.state || '',
            // country: State?.Country?.country || ''
            state: State?.id || '',
            country: State?.Country?.id || ''
          });
        } else {
          message.error('State information is missing.');
        }
      } else {
        message.error('Failed to fetch state and country.');
      }
    } catch (error) {
      console.error('Error fetching details:', error);
      message.error('Error fetching details.');
    }
  };

  // Format number with commas (e.g., 1000000 => 1,000,000)
  const formatWithCommas = (value) => {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // Handle input change (only allow digits)
  const handleIncomeChange = (e) => {
    const rawValue = e.target.value.replace(/[^\d]/g, ''); // Allow only digits
    setIncome(formatWithCommas(rawValue)); // Update with formatted value
  };

  // Parse value back to a clean number (without commas)
  // const getRawValue = (value) => value.replace(/,/g, '');
  // console.log('setIncome', income);

  return (
    <div className={styles.maincontainer}>
      <div className={styles.editOuter}>
        {/* <div className={styles.ButtonSet}>
            <button className={styles.primaryButton}>Back</button>
          </div> */}
        <div className={styles.singleContainer}>
          <Row
            gutter={24}
            style={{ width: '100%' }}
            className={styles.aboutimgstyles}
          >
            <Col
              xl={7}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <div className={styles.leftimgcontainer}>
                {/* <img src={LeftImg} /> */}
                <div className={styles.overlayText}>
                  <h2 className={styles.title}>THE TALE OF</h2>
                  <h1 className={styles.bigTitle}>TWO</h1>
                </div>
              </div>
            </Col>
            <Col
              xl={16}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={styles.leftspace}
            >
              <Form form={form} onFinish={onFinish} layout="vertical">
                <div className={styles.detailSide}>
                  <div className={styles.detailName}>
                    <div className={styles.nameflex}>
                      <div className={styles.idname}>
                        <h1 className={styles.dName}> {userName} </h1>
                        {/* <span> {profile_unique_id} </span> */}
                      </div>
                      {/* <div className={styles.matchpercent}>
                        <h6>
                          <span>96%</span> Away to find the right match
                        </h6>
                      </div> */}
                      <Row gutter={[8, 8]} wrap>
                        <Col className={styles.progressname}>
                          <Progress
                            size="small"
                            type="circle"
                            percent={percent}
                            // strokeColor={conicColors}
                            strokeColor={getStrokeColor(percent)}
                          />
                          <h6 className={styles.matchpercent}>
                            away to find your life partner
                          </h6>
                        </Col>
                      </Row>
                    </div>
                    <div className={styles.changes}>
                      {/* <div className={styles.textContainer}>
                        <img
                          src={EditIcon}
                          alt="Edit Profile"
                          className={styles.icon}
                        />
                        <div>Edit</div>
                      </div> */}

                      {/* <div className={styles.vBorder}></div>

                      <div className={styles.textContainer}>
                        <img
                          src={downloadIcon}
                          alt="Download Profile"
                          className={styles.icon}
                        />
                        <div>Download</div>
                      </div> */}
                    </div>
                  </div>
                  <div>
                    <div className={styles.detailsOuter}>
                      <div className={styles.detailsInner}>
                        <div className={styles.detailsInside}>
                          {/* Tabs Content */}
                          <div className={styles.searchTab}>
                            {Object.keys(routes).map((section) => (
                              <div
                                key={section}
                                className={`${styles.searchTabHeader} ${
                                  activeTab === section ? styles.activeTab : ''
                                }`}
                                onClick={() => handleSectionClick(section)}
                              >
                                {section}
                              </div>
                            ))}
                          </div>
                          {/* Tabs Content */}
                          <div>
                            <Row className={styles.mainContainerStyle}>
                              <Col
                                xs={24}
                                xl={24}
                                sm={12}
                                md={12}
                                className={styles.sideheader}
                              >
                                <div className={styles.right_outer_container}>
                                  {/* <Form layout="vertical"> */}

                                  {/* Education Level */}
                                  <div className={styles.educationRow}>
                                    <Form.Item
                                      label="Education Details"
                                      className={styles.formLabel}
                                      required
                                    >
                                      {educationFields.map((_, index) => (
                                        <div
                                          key={index}
                                          className={styles.fieldsContainer}
                                        >
                                          {/* Education Level */}
                                          <Form.Item
                                            // name="education_level"
                                            name={[
                                              'highestEducation',
                                              index,
                                              'education_level_id'
                                            ]}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  'Education level is required'
                                              }
                                            ]}
                                          >
                                            <Select
                                              placeholder="Select education level"
                                              showSearch
                                              // value={
                                              //   educationFields[index]
                                              //     ?.education_level_id
                                              // }
                                              value={
                                                education_level_listdata?.find(
                                                  (edulist) =>
                                                    edulist.id ===
                                                    educationFields[index]
                                                      ?.education_level_id
                                                )?.education_level || undefined
                                              }
                                              onChange={(value) =>
                                                handleFieldChange(
                                                  index,
                                                  'education_level_id',
                                                  value
                                                )
                                              }
                                              options={education_level_listdata?.map(
                                                (item) => ({
                                                  label: item.education_level, // Ensure this matches the correct field in your data
                                                  value: item.id // Ensure this is the correct ID for selection
                                                })
                                              )}
                                              optionFilterProp="label"
                                              // filterOption={(input, option) =>
                                              //   option?.children
                                              //     ?.toLowerCase()
                                              //     ?.includes(
                                              //       input.toLowerCase()
                                              //     )
                                              // }
                                              filterOption={(input, option) =>
                                                option.label
                                                  .toLowerCase()
                                                  .includes(input.toLowerCase())
                                              }
                                              // onChange={handleCityChange}
                                            >
                                              {education_level_listdata?.map(
                                                (edulist) => (
                                                  <Select.Option
                                                    key={edulist.id}
                                                    value={edulist.id}
                                                  >
                                                    {edulist.education_level}
                                                  </Select.Option>
                                                )
                                              )}
                                            </Select>
                                          </Form.Item>

                                          {/* Degree */}
                                          <Form.Item
                                            // name="education"
                                            name={[
                                              'highestEducation',
                                              index,
                                              'higher_education_id'
                                            ]}
                                            rules={[
                                              {
                                                required: true,
                                                message: 'Degree is required'
                                              }
                                            ]}
                                          >
                                            <Select
                                              placeholder="Select degree"
                                              showSearch
                                              value={
                                                educationFields[index]
                                                  ?.higher_education_id
                                              }
                                              onChange={(value) =>
                                                handleFieldChange(
                                                  index,
                                                  'higher_education_id',
                                                  value
                                                )
                                              }
                                              // options={(
                                              //   education_degree_listdata[
                                              //     educationFields[index]
                                              //       ?.education_level_id
                                              //   ] || []
                                              // ).map((list) => ({
                                              //   label: list.higher_education,
                                              //   value: list.id
                                              // }))}
                                              optionFilterProp="children"
                                              filterOption={(input, option) =>
                                                option?.children
                                                  ?.toLowerCase()
                                                  ?.includes(
                                                    input.toLowerCase()
                                                  )
                                              }
                                            >
                                              {/* {education_list?.map((list) => ( */}
                                              {/* {education_degree_listdata?.map(
                                                (list) => (
                                                  <Select.Option
                                                    key={list.id}
                                                    value={list.id}
                                                  >
                                                    {list.higher_education}
                                                  </Select.Option>
                                                )
                                              )} */}
                                              {(
                                                education_degree_listdata[
                                                  educationFields[index]
                                                    ?.education_level_id
                                                ] || []
                                              ).map((list) => (
                                                <Select.Option
                                                  key={list.id}
                                                  value={list.id}
                                                >
                                                  {list.higher_education}
                                                </Select.Option>
                                              ))}
                                            </Select>
                                          </Form.Item>

                                          {/* Institute Name */}
                                          <Form.Item
                                            name={[
                                              'highestEducation',
                                              index,
                                              'institute_name'
                                            ]}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  'Institute name is required'
                                              }
                                            ]}
                                          >
                                            <Input
                                              placeholder="Enter name of the institution"
                                              value={
                                                educationFields[index]
                                                  ?.institute_name
                                              }
                                              onChange={(e) =>
                                                handleFieldChange(
                                                  index,
                                                  'institute_name',
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Form.Item>
                                          {educationFields.length > 1 && (
                                            <DeleteOutlined
                                              className={styles.deleteIcon}
                                              onClick={() =>
                                                removeEducationField(index)
                                              }
                                            />
                                          )}
                                        </div>
                                      ))}
                                      <div
                                        className={styles.addDegree}
                                        onClick={addEducationField}
                                      >
                                        + Add Another Degree
                                      </div>
                                    </Form.Item>
                                  </div>

                                  {/* Education Details Done */}

                                  <Form.Item
                                    name="employmentType"
                                    label="Employed in"
                                    className={styles.employedTitle}
                                  >
                                    <Radio.Group
                                      options={options}
                                      className={styles.checkboxGroup}
                                    />
                                  </Form.Item>
                                  <div className={styles.formRow}>
                                    <div className={styles.formColumn}>
                                      <Form.Item
                                        name="department"
                                        label="Department / Sector"
                                      >
                                        <Select
                                          placeholder="Select department / sector"
                                          showSearch
                                          optionFilterProp="children"
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                        >
                                          {department_details?.length
                                            ? department_details?.map(
                                                (department, index) => {
                                                  return (
                                                    <option
                                                      value={department?.id}
                                                      key={index}
                                                    >
                                                      {department?.department}
                                                    </option>
                                                  );
                                                }
                                              )
                                            : ''}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                    <div className={styles.formColumn}>
                                      <Text className={styles.labels}>
                                        Annual Income
                                      </Text>
                                      <Form.Item
                                        // label="Phone Number"
                                        name="phone"
                                        rules={[
                                          {
                                            required: false,
                                            message:
                                              'Please select currency and enter income'
                                          }
                                        ]}
                                        className={styles.fullWidthItem}
                                      >
                                        <Input.Group
                                          compact
                                          className={
                                            styles.customInputContainer
                                          }
                                        >
                                          <Form.Item
                                            name="currency"
                                            noStyle
                                            initialValue={1}
                                          >
                                            <Select
                                              style={{ width: '20%' }}
                                              showSearch
                                              placeholder="Select country code"
                                              className="custom-select"
                                              optionFilterProp="children"
                                              getPopupContainer={(
                                                triggerNode
                                              ) => triggerNode.parentNode} // Ensures correct styling
                                              dropdownStyle={{
                                                borderRadius: '8px'
                                              }} // Apply radius to dropdown
                                              filterOption={(input, option) =>
                                                option.children
                                                  .toLowerCase()
                                                  .includes(input.toLowerCase())
                                              }
                                            >
                                              {currency_data?.length
                                                ? currency_data?.map(
                                                    (cdata, index) => {
                                                      return (
                                                        <option
                                                          value={cdata?.id}
                                                          key={index}
                                                        >
                                                          {cdata?.currency_code}
                                                        </option>
                                                      );
                                                    }
                                                  )
                                                : ''}
                                            </Select>
                                          </Form.Item>
                                          {/* <span className={styles.divider}>
                                            |
                                          </span> */}
                                          <Form.Item
                                            name="annual_income"
                                            noStyle
                                          >
                                            <Input
                                              placeholder="Enter annual income"
                                              type="number"
                                              // value={formattedIncome}
                                              // maxLength={15}
                                              // onChange={handleIncomeChange}
                                              value={income}
                                              onChange={handleIncomeChange}
                                              // className={
                                              //   styles.hideNumberSpinners
                                              // }
                                              style={{
                                                width: '80%',
                                                marginLeft: '-6px'
                                                // height: '39.5px'
                                              }}
                                            />
                                          </Form.Item>
                                        </Input.Group>
                                      </Form.Item>
                                    </div>
                                  </div>

                                  {/* Company and Designation Section */}
                                  <div className={styles.formRow}>
                                    <div className={styles.formColumn}>
                                      {/* <div className={styles.sectionTitle}>Company Name</div>
                <Input className={styles.input} placeholder="Company Name" /> */}
                                      <Form.Item
                                        name="companyName"
                                        label="Company Name"
                                      >
                                        <Input
                                          placeholder="Enter company name"
                                          className={styles.inputstyle}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div className={styles.formColumn}>
                                      {/* <div className={styles.sectionTitle}>Designation</div>
                <Input
                  className={styles.input}
                  placeholder="Designation / Role"
                /> */}
                                      <Form.Item
                                        name="designation"
                                        label="Designation"
                                      >
                                        <Input
                                          placeholder="Enter designation / role"
                                          className={styles.inputstyle}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>

                                  {/* Location Section */}
                                  <div className={styles.formRow}>
                                    <div className={styles.formColumn}>
                                      {/* <div className={styles.sectionTitle}>Country</div>
                <Select
                  className={styles.select}
                  placeholder="Select Country"
                /> */}
                                      {/* City */}
                                      <Form.Item name="city" label="City">
                                        <Select
                                          placeholder="Select city"
                                          showSearch
                                          optionFilterProp="children"
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                          onChange={handleCityChange}
                                        >
                                          {city_details?.length
                                            ? city_details?.map(
                                                (city, index) => {
                                                  return (
                                                    <option
                                                      value={city?.id}
                                                      key={index}
                                                    >
                                                      {city?.city}
                                                    </option>
                                                  );
                                                }
                                              )
                                            : ''}
                                        </Select>
                                      </Form.Item>
                                    </div>

                                    <div className={styles.formColumn}>
                                      {/* <div className={styles.sectionTitle}>City</div>
                                      <Select className={styles.select} placeholder="Select City" /> */}
                                      <Form.Item name="state" label="State">
                                        <Select
                                          disabled
                                          placeholder="Select state"
                                          showSearch
                                          optionFilterProp="children"
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                        >
                                          {state_details?.length
                                            ? state_details?.map(
                                                (state, index) => {
                                                  return (
                                                    <option
                                                      value={state?.id}
                                                      key={index}
                                                    >
                                                      {state?.state}
                                                    </option>
                                                  );
                                                }
                                              )
                                            : ''}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                    {/* Country */}

                                    {/* City */}
                                    <div className={styles.formColumn}>
                                      {/* <div className={styles.sectionTitle}>City</div>
                                      <Select className={styles.select} placeholder="Select City" /> */}
                                      <Form.Item name="country" label="Country">
                                        <Select
                                          disabled
                                          placeholder="Select country"
                                          showSearch
                                          optionFilterProp="children"
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                        >
                                          {country_codes?.length
                                            ? country_codes?.map(
                                                (code, index) => {
                                                  return (
                                                    <option
                                                      value={code?.id}
                                                      key={index}
                                                    >
                                                      {code?.country}
                                                    </option>
                                                  );
                                                }
                                              )
                                            : ''}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <br />
                                  <Form.Item>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className={styles.submitbutton}
                                      loading={createEducationDetailsloading}
                                      disabled={createEducationDetailsloading}
                                    >
                                      Save & Next
                                    </Button>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Edit;
